import styled from '@emotion/styled';

export const Title = styled.h1`
  font-size: 2.6rem;
  font-weight: normal;
  margin: 0 0 2.7rem;
`;

export const DownloadDiv = styled.div`
  float: right;
`;
